<template>
  <div>
    <!-- Button to trigger Edit -->
    <button v-if="displayType === 'dropdown-item'" @click="editRingsClicked" class="text-gray-900 group flex w-full items-center px-2 py-2 text-gray-800 hover:bg-gray-200">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 8.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v8.25A2.25 2.25 0 006 16.5h2.25m8.25-8.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-7.5A2.25 2.25 0 018.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 00-2.25 2.25v6" />
      </svg>
      Configure Rings
    </button>
    <button v-else @click="editRingsClicked" class="btn-sm btn-blue-outline">Configure Rings</button>
    <b-modal ref="ringModal" title="Configure Rings" no-close-on-backdrop>
      <tabs type="classic">
        <tab :selected="true" name="Rings" class="mt-4">
          <div class="flex justify-end mb-2">
            <button @click="addNewRing" type="button" class="inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Add Ring</button>
          </div>
          <div v-for="(r, i) in ring_settings" :key="i" class="p-3 rounded mb-4 bg-gray-200">
            <div class="mb-2 flex justify-between items-end space-x-4">
              <div class="w-full">
                <label for="name" class="block text-sm font-medium text-gray-700">Ring Name</label>
                <div class="mt-0 border-b border-gray-300 focus-within:border-blue-600">
                  <input v-model="r.name" type="text" name="name" id="name" class="block w-full border-0 border-b border-transparent bg-gray-200 focus:border-blue-600 focus:ring-0 text-xl" placeholder="New Ring">
                </div>
              </div>
              <button type="button" @click="ring_settings.splice(i,1)" class="flex-shrink-0 inline-flex items-center rounded border border-transparent bg-red-100 px-2.5 py-1.5 text-xs font-medium text-red-700 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2">Remove Ring</button>
            </div>
            <div>
              <label for="name" class="block text-sm font-medium text-gray-700">Divisions</label>
              <v-select multiple v-model="r.divisions" :options="divisions" :closeOnSelect="false">
              </v-select>
            </div>
          </div>
        </tab>
        <tab name="Edit Ring By Class" v-if="adminData.event.event_settings.class_ring_modifier">
          <div v-for="(c, i) in show_book.show_book" :key="i">
            <template v-if="c.entryType === 'standard'">
              <template v-for="(eb, j) in c.entry_breaks">
                <div v-if="eb.type === 'break'" :key="j" class="flex justify-between items-center border-b p-1">
                  <p>{{`${eb.division} ${eb.name}`}} <span v-if="eb.sub_division">({{eb.sub_division}})</span></p>
                  <div class='inline-flex items-center space-x-2'>
                    <p>({{getDefaultRing(c)}})</p>
                    <v-select
                        class="w-48"
                        v-model="eb.ring_id"
                        :options="ring_list"
                        :reduce="option => option"
                        :clearable="false"
                      >
                    </v-select>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </tab>
      </tabs>
      <div slot="modal-footer" class="w-full">
        <div class="flex justify-end">
          <button class="btn-green btn-sm mr-2" variant="primary" @click="saveRingConfig">
            Save
          </button>
          <button class="btn-red-outline btn-sm" variant="primary" @click="cancelEdit">
            Cancel
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    displayType: String,
    show_book: Object
  },
  data () {
    return {
      divisionRings: new Set(),
      // classRings: [],
      originalRingSettings: {}
    }
  },
  methods: {
    editRingsClicked () {
      // this.setAllClassRingsNew()
      this.originalRingSettings = this.ring_settings ? [...this.ring_settings] : []
      this.$refs.ringModal.show()
    },
    getDefaultRing (c) {
      if (!this.ring_settings) {
        return ''
      }
      let setting = this.ring_settings.find(rs => {
        if (rs.divisions) {
          if (rs.divisions.includes(c.division)) {
            return true
          }
        }
      })
      return setting ? setting.name : ''
    },
    saveRingConfig () {
      let payload = {
        show_id: this.show_book.show_id,
        field: 'ring_settings',
        value: this.ring_settings
      }
      this.$store.dispatch('updateShowSettings', payload)
        .then(() => {
          this.notie.alert({
            type: 1,
            text: `Ring Config Successfully Updated`
          })
          this.$emit('ringUpdate', this.divisionRings)
          this.$refs.ringModal.hide()
        })
        .catch(() => {
          this.notie.alert({
            type: 3,
            text: `Error updating show, please check all fields and try again.<br>If error continues please submit a help ticket.`
          })
        })
    },
    cancelEdit () {
      this.show_book.show_settings.ring_settings = this.originalRingSettings
      this.$refs.ringModal.hide()
    },
    addNewRing () {
      if (this.ring_settings) {
        this.ring_settings.push({
          starting_class_number: 1,
          name: `Ring ${this.ring_settings.length + 1}`
        })
      } else {
        Vue.set(this.show_book.show_settings, 'ring_settings', [{starting_class_number: 1, name: `Ring 1`}])
      }
    }
  },
  computed: {
    adminData () {
      return this.$store.state.admin.adminData
    },
    ring_settings () {
      return this.show_book.show_settings.ring_settings
    },
    ring_list () {
      let ringList = []
      if (this.ring_settings) {
        this.show_book.show_settings.ring_settings.forEach(r => {
          if (r.name !== 'Overall') {
            ringList.push(r.name)
          }
        })
      }
      return ringList
    },
    divisions () {
      let div = []
      this.show_book.show_book.forEach(c => {
        if (c.entryType.toLowerCase() === 'standard' && !div.includes(c.division)) {
          div.push(c.division)
        }
      })
      return div
    }
  }
}
</script>

<style>

</style>
